<template>
  <div v-if="isShow" class="dv show">
    <AdBaseVue
      :tp="'M2'"
      :isShowColse="true"
      :google_pc_wid="'300px'"
      :google_pc_hgt="'600px'"
      @colse="isShow = false"
    ></AdBaseVue>
  </div>
</template>

<script>
import AdBaseVue from "./AdBase.vue";
export default {
  components: {
    AdBaseVue,
  },
  data() {
    return {
      isShow: true,
    };
  },
  methods: {
    colse() {
      this.isShow = false;
    },
  },
};
</script>

<style scoped>
.show {
  display: none;
}
@media (max-width: 575px) {
  .show {
    display: block;
  }
}
.dv {
  width: 100%;
  height: 90px;
  /*   background-color: red; */
  position: fixed;
  bottom: 0px;
  z-index: 99999;
}
</style>


// WEBPACK FOOTER //
// src/components/Ad/M2.vue